import { FormValidator, ValidationRules } from 'src/utils/FormValidator';
import { ERROR_MESSAGES, VALIDATION_PATTERNS } from 'src/contstant/commonLabels';

export const TaskValidator = (): FormValidator => {
  const validator = new FormValidator();

  validator.addRule('taskName', ValidationRules.required, 'Error: Task name is required');
  validator.addRule(
    'taskDurationDays',
    (value: number) => value >= 1,
    'Error: Task duration must be at least 1 day',
  );
  validator.addRule(
    'taskDescription',
    ValidationRules.required,
    'Error: Task description is required',
  );
  validator.addRule('assignee', ValidationRules.required, 'Error: Assignee is required');
  validator.addRule(
    'assignee',
    (value: string) => VALIDATION_PATTERNS.ASSIGNEE_ALIAS.test(value),
    `Error: ${ERROR_MESSAGES.ASSIGNEE_AT_SYMBOL}`,
  );

  return validator;
};
